// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oyuf","right":"styles_right__1mQIg"};